<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <van-list
      v-model="isLoading"
      :finished="finished"
      :finished-text="finishedtext"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
      class="items"
      ref="body"
    >
      <div v-for="item in list" :key="item.id" class="items-item">
        <van-cell-group @click="toDetail(item)">
          <van-cell class="items-infos">
            <van-col span="6">
              <div :style="imageStyle">
                <van-image
                  fit="cover"
                  lazy-load
                  :src="rootPath + item.img"
                  width="100%"
                />
              </div>
            </van-col>
            <van-col span="18" class="items-detail">
              <div class="infobox">
                <div class="orderno font-bold">{{ item.orderno }}</div>
                <div class="name">{{ item.title }}</div>
                <div class="pricename">{{ item.pricename }}</div>
              </div>
              <div class="pricebox">
                <div v-if="!type" class="tags">{{ orderStatus[item.status + ''] }}</div>
                <div class="price"><small>¥</small><span class="font-bold">{{ item.price }}</span></div>
                <div class="count"> × {{ item.count }}</div>
              </div>
            </van-col>
            <van-col span="24">
              <div class="items-amount">
                <div class="items-time">下单：{{ item.createtime }}</div>
                <div class="amount">合计：<small>¥</small><span class="font-bold">{{ formatPrice(item.amount) }}</span></div>
              </div>
            </van-col>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell class="items-btns">
            <!-- <van-button v-if="!item.iskp && item.status && item.status < 2" plain type="info" size="small" class="checkcode1-button" @click="handleOpenCheckcode(item)">
              <div class="checkcode1"><span>校验码</span></div>
            </van-button> -->
            <!-- <van-button v-if="item.status && item.isreservation && !item.yyid" type="info" size="small" @click.stop="openYy(item)">预约</van-button>
            <div v-if="item.yyid" class="items-yystatus" @click="openYy(item)">
              预约状态：
              <van-tag :type="yyStatusType(item)">{{ yyStatus[item.yystatus + ''] }}</van-tag>
            </div> -->
            <van-button v-if="!item.status || item.status == 3" size="small" @click.stop="doDel(item)">删除订单</van-button>
            <van-button v-if="!item.status" type="primary" size="small" @click.stop="doPay(item)">支付</van-button>
          </van-cell>
        </van-cell-group>
      </div>
    </van-list>
    <van-popup
      v-model="showcheckcode"
      closeable
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <van-cell-group :title="currentItem.title">
        <van-cell title="校验码" :value="currentItem.checkcode" class="popup-checkcode" />
        <van-cell class="popup-qrcode">
          <img :src="qrcodeUrl">
        </van-cell>
        <van-cell v-if="!subscribe" title="关注公众号" @click="showPop">
          <van-icon
            slot="right-icon"
            name="chat-o"
            style="line-height: inherit;"
          />
          <div slot="label">
            关注【{{ wxname }}】公众号，随时了解订单状态、获取最新优惠
          </div>
        </van-cell>
        <van-button v-if="subscribe && currentItem.status && currentItem.status < 2 && hasSendWx(currentItem)" block type="info" @click.stop="doSendWx(currentItem)">发送校验码到微信</van-button>
      </van-cell-group>
    </van-popup>
    <order-yy :item="currentItem" ref="orderyy" />
  </van-pull-refresh>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from '@/utils/tools';
import { orderStatusType } from '../global';
import QRCode from 'qrcode';
import OrderYy from './order-yy.vue';
export default {
  mixins: [tools],
  components: {
    OrderYy
  },
  props: {
    type: String
  },
  data() {
    return {
      isLoading: false,
      finished: false,
      error: false,
      count: 0,
      page: 1,
      list: [],
      searchData: {_status:null, y:false},
      qrcodeUrl: null,
      subscribe: 0,
      showcheckcode: false,
      showyy: false,
      w: 0,
      currentItem: {}
    }
  },
  computed: {
    ...mapGetters({
      orderStatus: [types.STATUS.orderStatus],
      // yyStatus: [types.STATUS.yyStatus]
    }),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w / 4 * 0.8) + 'px'};
      }
      return style;
    }
  },
  watch: {
    type(val) {
      let type = val;
      if (!type) {
        type = null;
      }
      this.searchData._status = type && !isNaN(type) ? parseInt(type) : null;
      this.searchData.y = type && type == 'Y';
      
      this.page = 1;
      this.loadData();

      this.dispatch('shopOrder', 'type.change', {type: val || null});
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
    this.getImgW();
    let type = this.type || null;
    this.searchData._status = type && !isNaN(type) ? parseInt(type) : null;
    this.searchData.y = type && type == 'Y';

    this.page = 1;
    // this.loadData();

    this.dispatch('shopOrder', 'type.change', {type: this.type || null});
  },
  updated() {
    if (!this.list || !this.list.length) {
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.orderyy.visible) {
      this.$refs.orderyy.show(false);
      next(false);
    } else {
      next();
    }
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'vue/personal/orders',
        data: Object.assign({}, {pageCurrent: this.page}, this.searchData),
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.listCb(json);
          }
          // 更新readtime
          this.updateReadtime(json.page.list);
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
      if (!this.orderStatus || !Object.keys(this.orderStatus).length) {
        this.$store.dispatch(types.STATUS.orderStatus);
      }
      // if (!this.yyStatus || !Object.keys(this.yyStatus).length) {
      //   this.$store.dispatch(types.STATUS.yyStatus);
      // }
    },
    listCb(json) {
      this.list = json.page.list;
      this.page = json.page.pageNumber;
      this.subscribe = json.subscribe;
    },
    updateReadtime(list) {
      if (this.type < 1 || this.type > 3) {
        return;
      }
      let _list = list.filter(d => {
        return !d.readtime;
      }).map(d => {
        return { id: d.id };
      });
      this.doPost({
        url: 'vue/personal/readtime',
        data: _list,
        okcb: () => {
          // vuex
          this.$store.commit(types.OTHER.reloadWebUser);
        }
      })
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.$el.offsetWidth;
      });
    },
    orderStatusType(item) {
      return orderStatusType(item.status);
    },
    // yyStatusType(item) {
    //   return yyStatusType(item.yystatus);
    // },
    formatPrice(price) {
      return price.toFixed(2);
    },
    onRefresh() {
      this.isLoading = false;
      this.page = 1;
      this.loadData((json) => {
        this.listCb(json);

        this.$toast('刷新成功');
      });
    },
    onLoad() {
      this.isLoading = false;
      this.finished = false;
      this.page = this.list.length ? this.page + 1 : 1;
      this.loadData((json) => {
        this.list = this.list.concat(json.page.list);
        this.page = json.page.pageNumber;

        // 如果已加载完
        if (!json.totalRow || json.page.totalPage <= json.page.pageNumber) {
          this.finished = true;
        }
      });
    },
    toDetail(item) {
      this.$router.push('/order/'+ item.id);
    },
    // 打开校验码界面
    handleOpenCheckcode(item) {
      this.currentItem = item;
      this.showcheckcode = true;
      this.qrcodeUrl = '';
      let text = this.BASEPATH + '/shop/check/'+ this.id;
      QRCode.toDataURL(text, {margin:1, width:130, height:130, color:{light:'#FFFFFFCC'}})
        .then(url => {
          // console.log(url)
          this.qrcodeUrl = url;
        })
        .catch(err => {
          // console.error(err)
        });
    },
    showPop() {
      if (this.$parent.$parent) {
        this.$parent.$parent.$emit('showpop');
      }
    },
    hasSendWx(item) {
      // 如果[未发送 或 现在时间 - 发送时间 < 10分钟，则可发送
      if (!item.send4wx || (Date.now() - (item.send4wx.toDate()).getTime() < 10 * 60)) {
        return true;
      }
      return false;
    },
    doSendWx(item) {
      this.Dialog.confirm({
        title: '发送校验码到微信',
        message: '确定要发送该校验码到微信吗？如果未关注【旅朋友福利社】公众号，将不能发送成功！'
      }).then(() => {
        this.doGet({
          url: 'vue/personal/sendCode4Wx/'+ item.id,
          okcb: (json) => {

          },
          cb: () => {
            
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    login() {
      // 如果是微信浏览器，记住登录后返回地址
      let backUrl = this.$route.path;
      this.doLogin(backUrl);
    },
    doDel(item) {
      this.Dialog.confirm({
        message: '确定要删除该订单吗？'
      }).then(() => {
        this.Toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        this.doPost({
          url: 'vue/personal/order/del/'+ item.id,
          okcb: (json) => {
            this.list.splice(this.list.indexOf(item), 1);
            setTimeout(() => {
              this.Toast.success('删除成功！');
            }, 300);
          },
          cb: () => {
            this.Toast.clear();
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    doPay(item) {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || !this.member.openid) {
        this.login();
        return;
      }
      if (item.iskp) {
        // 跳转订单页
        this.$router.push({name:'site-kp-order', params:{ id: item.id, back:'/orders/'+ (this.type || '') }});
        return;
      }
      this.doPost({
        url: 'vue/pay/wxpay2/'+ item.id,
        data: {openid: this.member.openid},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            this.Toast('已完成支付！');
            item.status = json.status;
            return;
          }
          let params = {goods: {name: item.title, amount: item.amount, price: item.price, count: item.count}, orderid: json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'goods-pay', params: params });
        },
        cb: () => {

        }
      });
    },
    // 打开预约界面
    openYy(item) {
      this.showyy = true;
      if (!item.yy) {
        this.$set(item, 'yy', item._yys ? JSON.parse(item._yys) : {});
      }
      this.currentItem = item;

      this.$refs.orderyy.show(true);
    }
  }
}
</script>

<style lang="less" scoped>
.font-bold {
  font-weight:bold;
}
.items {
  min-height:calc(100vh - 46px - 44px - 50px);
  &-item {
    position:relative;
    margin-top:1rem;
    .shadow_blur_black(4, .06);
    .van-cell {
      padding:1rem .8rem;
    }
    .van-cell:not(:last-child)::after{
      left:0;
    }
    .van-hairline--top-bottom::after{
      border-width:0;
    }
    &:first-child {
      margin-top:0;
    }
  }
  &-infos {
    .van-image{
      height:100%;
      overflow:hidden;
      border-radius:.5rem;
    }
    img {
      display: block;
    }
  }
  &-detail {
    margin-top:-.31rem;
    padding-left:.5rem;
    .flex-between();
    .fontsize();
    small {
      display:inline-block;
      margin-right:2px;
    }
    .pricename {
      color:#999;
    }
    .orderno {
      .text-more();
    }
    .infobox {
      margin-right:1rem;
      .name {
        line-height:1.3;
      }
    }
    .pricebox {
      flex-shrink:0;
      text-align:right;
      .tags {
        color:#f44;
      }
    }
  }
  &-amount {
    .flex-between();
    margin-top:.25rem;
    padding-top:.25rem;
    .border-p(top, #eee);
  }
  &-time {
    font-size:.9rem;
    color:#777;
  }
  &-title {
    .fontsize();
    line-height:1.45;
  }
  &-price {
    .fontsize(1.2rem);
    color: #f44;
  }
  &-yystatus {
    padding:0 .5rem;
    height:28px;
    line-height:28px;
    border:1px #ccc solid;
  }
  &-btns {
    background-color:#f8f8f8;
    &.van-cell {
      margin-top:-.3rem;
      padding:0.5rem 0.8rem;
    }
    .van-cell.qrcode {
      .van-cell__value--alone {
        .flex-center-h();
      }
    }
    .van-button.checkcode1-button {
      padding-right:1rem;
    }
    .checkcode1 {
      position:relative;
      .fontsize();
      line-height:1.5;
      & > span {
        padding-right:.4rem;
      }
      &::after {
        position: absolute;
        top: 50%;
        right: -4px;
        margin-top: -5px;
        border: 3px solid;
        border-color: transparent transparent currentColor currentColor;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        opacity: .8;
        content: '';
      }
    }
    .van-cell__value--alone {
      .flex();
      justify-content:flex-end;
      align-items:center;
      > .van-button, .items-yystatus {
        margin-left:1rem;
      }
    }
  }
}
.popup-checkcode .van-cell__value {
  .fontsize(1.2rem);
  color:@orangecolor;
}
.popup-qrcode .van-cell__value {
  text-align:center;
}
</style>